module.exports = __webpack_public_path__ + "static/media/blurple.47cc6a78.svg";